<template>
	<transition name="error">
		<div class="error">
			<p>{{msg}}</p>
		</div>
	</transition>
</template>
<script>
export default {
	name: "error",
	data() {
		return {
			msg: "Нет соединения с сервером =("
		};
	}
};
</script>
<style scoped lang="scss">
.error {
	z-index: 200;
	position: absolute;
	min-width: 20rem;
	max-width: 25rem;
	padding: 2rem 0;
	margin-top: 5rem;
	background-color: rgba(255, 213, 209, 0.55);
	border-radius: 0.5rem;
	right: 50%;
	transform: translateX(50%);
	box-shadow: inset 0 0 5px #333333, 0 0 1rem #333;

	p {
		text-align: center;
		font-size: 2rem;
		color: #b90900;
	}
}

@media (max-width: 620px) {
	.error {
		margin-top: 9rem;
	}
}

.error-enter-active {
	transition: all 0.3s ease;
}

.error-leave-active {
	transition: all 0.8s ease;
}

.error-enter, .error-leave-to {
	transform: translateX(10px);
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Error.vue